"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TezosMessageUtil_1 = require("./TezosMessageUtil");
const TezosLanguageUtil_1 = require("./TezosLanguageUtil");
const operationTypes = new Map([
    [0, 'endorsement'],
    [1, 'seedNonceRevelation'],
    [2, 'doubleEndorsementEvidence'],
    [3, 'doubleBakingEvidence'],
    [4, 'accountActivation'],
    [5, 'proposal'],
    [6, 'ballot'],
    [7, 'reveal'],
    [8, 'transaction'],
    [9, 'origination'],
    [10, 'delegation'],
    [107, 'reveal'],
    [108, 'transaction'],
    [109, 'origination'],
    [110, 'delegation']
]);
const sepyTnoitarepo = [...operationTypes.keys()].reduce((m, k) => { const v = operationTypes.get(k) || ''; if (m[v] > k) {
    return m;
} return Object.assign(Object.assign({}, m), { [v]: k }); }, new Map());
var TezosMessageCodec;
(function (TezosMessageCodec) {
    function getOperationType(hex) {
        return operationTypes.get(TezosMessageUtil_1.TezosMessageUtils.readInt(hex)) || '';
    }
    TezosMessageCodec.getOperationType = getOperationType;
    function idFirstOperation(hex) {
        return getOperationType(hex.substring(64, 66));
    }
    TezosMessageCodec.idFirstOperation = idFirstOperation;
    function parseOperation(hex, opType, isFirst = true) {
        switch (opType) {
            case "endorsement":
                throw new Error(`Unsupported operation type: ${opType}`);
            case "seedNonceRevelation":
                throw new Error(`Unsupported operation type: ${opType}`);
            case "doubleEndorsementEvidence":
                throw new Error(`Unsupported operation type: ${opType}`);
            case "doubleBakingEvidence":
                throw new Error(`Unsupported operation type: ${opType}`);
            case "accountActivation":
                throw new Error(`Unsupported operation type: ${opType}`);
            case "proposal":
                throw new Error(`Unsupported operation type: ${opType}`);
            case "ballot":
                return parseBallot(hex, isFirst);
            case "reveal":
                return parseReveal(hex, isFirst);
            case "transaction":
                return parseTransaction(hex, isFirst);
            case "origination":
                return parseOrigination(hex, isFirst);
            case "delegation":
                return parseDelegation(hex, isFirst);
            default:
                throw new Error(`Unsupported operation type: ${opType}`);
        }
    }
    TezosMessageCodec.parseOperation = parseOperation;
    function encodeOperation(message) {
        if (message.hasOwnProperty('pkh') && message.hasOwnProperty('secret')) {
            return encodeActivation(message);
        }
        if (message.hasOwnProperty('kind')) {
            const operation = message;
            if (operation.kind === 'reveal') {
                return encodeReveal(message);
            }
            if (operation.kind === 'transaction') {
                return encodeTransaction(message);
            }
            if (operation.kind === 'origination') {
                return encodeOrigination(message);
            }
            if (operation.kind === 'delegation') {
                return encodeDelegation(message);
            }
        }
        if (message.hasOwnProperty('vote')) {
            return encodeBallot(message);
        }
        throw new Error('Unsupported message type');
    }
    TezosMessageCodec.encodeOperation = encodeOperation;
    function encodeActivation(activation) {
        let hex = TezosMessageUtil_1.TezosMessageUtils.writeInt(sepyTnoitarepo['accountActivation']);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(activation.pkh).slice(4);
        hex += activation.secret;
        return hex;
    }
    TezosMessageCodec.encodeActivation = encodeActivation;
    function parseBallot(ballotMessage, isFirst = true) {
        let hexOperationType = isFirst ? ballotMessage.substring(64, 66) : ballotMessage.substring(0, 2);
        if (getOperationType(hexOperationType) !== 'ballot') {
            throw new Error('Provided operation is not a ballot');
        }
        let fieldoffset = 0;
        let branch = '';
        if (isFirst) {
            branch = TezosMessageUtil_1.TezosMessageUtils.readBranch(ballotMessage.substring(fieldoffset, fieldoffset + 64));
            fieldoffset += 64 + 2;
        }
        else {
            fieldoffset += 2;
        }
        const source = TezosMessageUtil_1.TezosMessageUtils.readAddress(ballotMessage.substring(fieldoffset, fieldoffset + 42));
        fieldoffset += 42;
        const period = parseInt(ballotMessage.substring(fieldoffset, fieldoffset + 8), 16);
        fieldoffset += 8;
        const proposal = TezosMessageUtil_1.TezosMessageUtils.readBufferWithHint(Buffer.from(ballotMessage.substring(fieldoffset, fieldoffset + 64), 'hex'), 'p');
        fieldoffset += 64;
        const vote = parseInt(ballotMessage.substring(fieldoffset, fieldoffset + 1), 16);
        fieldoffset += 2;
        let next;
        if (ballotMessage.length > fieldoffset) {
            next = getOperationType(ballotMessage.substring(fieldoffset, fieldoffset + 2));
        }
        const ballot = {
            kind: 'ballot',
            source: source,
            period: period,
            proposal: proposal,
            vote: vote
        };
        const envelope = {
            operation: ballot,
            branch: branch,
            next: next,
            nextoffset: next ? fieldoffset : -1
        };
        return envelope;
    }
    TezosMessageCodec.parseBallot = parseBallot;
    function encodeBallot(ballot) {
        let hex = TezosMessageUtil_1.TezosMessageUtils.writeInt(sepyTnoitarepo['ballot']);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(ballot.source).slice(2);
        hex += ('00000000' + ballot.period.toString(16)).slice(-8);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeBufferWithHint(ballot.proposal).toString('hex').slice(4);
        hex += ('00' + ballot.vote.toString(16)).slice(-2);
        return hex;
    }
    TezosMessageCodec.encodeBallot = encodeBallot;
    function parseReveal(revealMessage, isFirst = true) {
        let hexOperationType = isFirst ? revealMessage.substring(64, 66) : revealMessage.substring(0, 2);
        if (getOperationType(hexOperationType) !== 'reveal') {
            throw new Error('Provided operation is not a reveal.');
        }
        let fieldoffset = 0;
        let branch = '';
        if (isFirst) {
            branch = TezosMessageUtil_1.TezosMessageUtils.readBranch(revealMessage.substring(fieldoffset, fieldoffset + 64));
            fieldoffset += 64 + 2;
        }
        else {
            fieldoffset += 2;
        }
        let source = '';
        if (parseInt(hexOperationType, 16) < 100) {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(revealMessage.substring(fieldoffset, fieldoffset + 44));
            fieldoffset += 44;
        }
        else {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(revealMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let feeInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(revealMessage, fieldoffset);
        fieldoffset += feeInfo.length;
        let counterInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(revealMessage, fieldoffset);
        fieldoffset += counterInfo.length;
        let gasInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(revealMessage, fieldoffset);
        fieldoffset += gasInfo.length;
        let storageInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(revealMessage, fieldoffset);
        fieldoffset += storageInfo.length;
        let publickey = TezosMessageUtil_1.TezosMessageUtils.readPublicKey(revealMessage.substring(fieldoffset, fieldoffset + 66));
        fieldoffset += 66;
        let next;
        if (revealMessage.length > fieldoffset) {
            next = getOperationType(revealMessage.substring(fieldoffset, fieldoffset + 2));
        }
        const reveal = {
            kind: "reveal",
            source: source,
            public_key: publickey,
            fee: feeInfo.value + "",
            gas_limit: gasInfo.value + "",
            storage_limit: storageInfo.value + "",
            counter: counterInfo.value + ""
        };
        const envelope = {
            operation: reveal,
            branch: branch,
            next: next,
            nextoffset: next ? fieldoffset : -1
        };
        return envelope;
    }
    TezosMessageCodec.parseReveal = parseReveal;
    function encodeReveal(reveal) {
        if (reveal.kind !== 'reveal') {
            throw new Error('Incorrect operation type.');
        }
        let hex = TezosMessageUtil_1.TezosMessageUtils.writeInt(sepyTnoitarepo['reveal']);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(reveal.source).slice(2);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(reveal.fee));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(reveal.counter));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(reveal.gas_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(reveal.storage_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writePublicKey(reveal.public_key);
        return hex;
    }
    TezosMessageCodec.encodeReveal = encodeReveal;
    function parseTransaction(transactionMessage, isFirst = true) {
        let hexOperationType = isFirst ? transactionMessage.substring(64, 66) : transactionMessage.substring(0, 2);
        if (getOperationType(hexOperationType) !== "transaction") {
            throw new Error("Provided operation is not a transaction.");
        }
        let fieldoffset = 0;
        let branch = "";
        if (isFirst) {
            branch = TezosMessageUtil_1.TezosMessageUtils.readBranch(transactionMessage.substring(fieldoffset, fieldoffset + 64));
            fieldoffset += 64 + 2;
        }
        else {
            fieldoffset += 2;
        }
        let source = '';
        if (parseInt(hexOperationType, 16) < 100) {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(transactionMessage.substring(fieldoffset, fieldoffset + 44));
            fieldoffset += 44;
        }
        else {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(transactionMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let feeInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(transactionMessage, fieldoffset);
        fieldoffset += feeInfo.length;
        let counterInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(transactionMessage, fieldoffset);
        fieldoffset += counterInfo.length;
        let gasInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(transactionMessage, fieldoffset);
        fieldoffset += gasInfo.length;
        let storageInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(transactionMessage, fieldoffset);
        fieldoffset += storageInfo.length;
        let amountInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(transactionMessage, fieldoffset);
        fieldoffset += amountInfo.length;
        let target = TezosMessageUtil_1.TezosMessageUtils.readAddress(transactionMessage.substring(fieldoffset, fieldoffset + 44));
        fieldoffset += 44;
        let hasParameters = TezosMessageUtil_1.TezosMessageUtils.readBoolean(transactionMessage.substring(fieldoffset, fieldoffset + 2));
        fieldoffset += 2;
        let parameters = '';
        if (hasParameters && parseInt(hexOperationType, 16) < 100) {
            const paramLength = parseInt(transactionMessage.substring(fieldoffset, fieldoffset + 8), 16);
            fieldoffset += 8;
            const codeEnvelope = TezosLanguageUtil_1.TezosLanguageUtil.hexToMicheline(transactionMessage.substring(fieldoffset));
            parameters = codeEnvelope.code;
            if (codeEnvelope.consumed !== paramLength * 2) {
                throw new Error('Failed to parse transaction parameters: length mismatch');
            }
            fieldoffset += paramLength * 2;
        }
        else if (hasParameters && parseInt(hexOperationType, 16) > 100) {
            const entrypointType = parseInt(transactionMessage.substring(fieldoffset, fieldoffset + 2), 16);
            fieldoffset += 2;
            let entrypointName = '';
            if (entrypointType === 255) {
                const endpointLength = parseInt(transactionMessage.substring(fieldoffset, fieldoffset + 2), 16);
                fieldoffset += 2;
                entrypointName = Buffer.from(transactionMessage.substring(fieldoffset, fieldoffset + endpointLength * 2), 'hex').toString();
                fieldoffset += endpointLength * 2;
            }
            else if (entrypointType === 0) {
                entrypointName = 'default';
            }
            else if (entrypointType === 1) {
                entrypointName = 'root';
            }
            else if (entrypointType === 2) {
                entrypointName = 'do';
            }
            else if (entrypointType === 3) {
                entrypointName = 'set_delegate';
            }
            else if (entrypointType === 4) {
                entrypointName = 'remove_delegate';
            }
            const paramLength = parseInt(transactionMessage.substring(fieldoffset, fieldoffset + 8), 16);
            fieldoffset += 8;
            const codeEnvelope = TezosLanguageUtil_1.TezosLanguageUtil.hexToMicheline(transactionMessage.substring(fieldoffset));
            const endpointParameters = codeEnvelope.code;
            if (codeEnvelope.consumed !== paramLength * 2) {
                throw new Error('Failed to parse transaction parameters: length mismatch');
            }
            fieldoffset += paramLength * 2;
            parameters = { entrypoint: entrypointName, value: endpointParameters };
        }
        let next;
        if (transactionMessage.length > fieldoffset) {
            next = getOperationType(transactionMessage.substring(fieldoffset, fieldoffset + 2));
        }
        const transaction = {
            kind: "transaction",
            source: source,
            destination: target,
            amount: amountInfo.value.toString(),
            fee: feeInfo.value.toString(),
            gas_limit: gasInfo.value.toString(),
            storage_limit: storageInfo.value.toString(),
            counter: counterInfo.value.toString(),
            parameters: parameters
        };
        const envelope = {
            operation: transaction,
            branch: branch,
            next: next,
            nextoffset: next ? fieldoffset : -1
        };
        return envelope;
    }
    TezosMessageCodec.parseTransaction = parseTransaction;
    function encodeTransaction(transaction) {
        if (transaction.kind !== 'transaction') {
            throw new Error('Incorrect operation type');
        }
        let hex = TezosMessageUtil_1.TezosMessageUtils.writeInt(sepyTnoitarepo['transaction']);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(transaction.source).slice(2);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(transaction.fee));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(transaction.counter));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(transaction.gas_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(transaction.storage_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(transaction.amount));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(transaction.destination);
        if (!!transaction.parameters) {
            const composite = transaction.parameters;
            const code = TezosLanguageUtil_1.TezosLanguageUtil.normalizeMichelineWhiteSpace(JSON.stringify(composite.value));
            const result = TezosLanguageUtil_1.TezosLanguageUtil.translateMichelineToHex(code);
            if ((composite.entrypoint === 'default' || composite.entrypoint === '') && result === '030b') {
                hex += '00';
            }
            else {
                hex += 'ff';
                if (composite.entrypoint === 'default' || composite.entrypoint === '') {
                    hex += '00';
                }
                else if (composite.entrypoint === 'root') {
                    hex += '01';
                }
                else if (composite.entrypoint === 'do') {
                    hex += '02';
                }
                else if (composite.entrypoint === 'set_delegate') {
                    hex += '03';
                }
                else if (composite.entrypoint === 'remove_delegate') {
                    hex += '04';
                }
                else {
                    hex += 'ff'
                        + ('0' + composite.entrypoint.length.toString(16)).slice(-2)
                        + composite.entrypoint.split('').map(c => c.charCodeAt(0).toString(16)).join('');
                }
                hex += ('0000000' + (result.length / 2).toString(16)).slice(-8) + result;
            }
        }
        else {
            hex += '00';
        }
        return hex;
    }
    TezosMessageCodec.encodeTransaction = encodeTransaction;
    function parseOrigination(originationMessage, isFirst = true) {
        let hexOperationType = isFirst ? originationMessage.substring(64, 66) : originationMessage.substring(0, 2);
        if (getOperationType(hexOperationType) !== "origination") {
            throw new Error("Provided operation is not an origination.");
        }
        let fieldoffset = 0;
        let branch = "";
        if (isFirst) {
            branch = TezosMessageUtil_1.TezosMessageUtils.readBranch(originationMessage.substring(fieldoffset, fieldoffset + 64));
            fieldoffset += 64 + 2;
        }
        else {
            fieldoffset += 2;
        }
        let source = '';
        if (parseInt(hexOperationType, 16) < 100) {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(originationMessage.substring(fieldoffset, fieldoffset + 44));
            fieldoffset += 44;
        }
        else {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(originationMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let feeInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(originationMessage, fieldoffset);
        fieldoffset += feeInfo.length;
        let counterInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(originationMessage, fieldoffset);
        fieldoffset += counterInfo.length;
        let gasInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(originationMessage, fieldoffset);
        fieldoffset += gasInfo.length;
        let storageInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(originationMessage, fieldoffset);
        fieldoffset += storageInfo.length;
        let manager_pubkey = '';
        if (parseInt(hexOperationType, 16) < 100) {
            manager_pubkey = TezosMessageUtil_1.TezosMessageUtils.readAddress(originationMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let balanceInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(originationMessage, fieldoffset);
        fieldoffset += balanceInfo.length;
        let spendable = false;
        let delegatable = false;
        if (parseInt(hexOperationType, 16) < 100) {
            spendable = TezosMessageUtil_1.TezosMessageUtils.readBoolean(originationMessage.substring(fieldoffset, fieldoffset + 2));
            fieldoffset += 2;
            delegatable = TezosMessageUtil_1.TezosMessageUtils.readBoolean(originationMessage.substring(fieldoffset, fieldoffset + 2));
            fieldoffset += 2;
        }
        let hasDelegate = TezosMessageUtil_1.TezosMessageUtils.readBoolean(originationMessage.substring(fieldoffset, fieldoffset + 2));
        fieldoffset += 2;
        let delegate = '';
        if (hasDelegate) {
            delegate = TezosMessageUtil_1.TezosMessageUtils.readAddress(originationMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let hasScript = true;
        if (parseInt(hexOperationType, 16) < 100) {
            hasScript = TezosMessageUtil_1.TezosMessageUtils.readBoolean(originationMessage.substring(fieldoffset, fieldoffset + 2));
            fieldoffset += 2;
        }
        let script = {};
        if (hasScript) {
            let codesize = parseInt(originationMessage.substring(fieldoffset, fieldoffset + 8), 16);
            fieldoffset += 8;
            const code = TezosLanguageUtil_1.TezosLanguageUtil.hexToMicheline(originationMessage.substring(fieldoffset, fieldoffset + codesize * 2)).code;
            fieldoffset += codesize * 2;
            let storagesize = parseInt(originationMessage.substring(fieldoffset, fieldoffset + 8), 16);
            fieldoffset += 8;
            const storage = TezosLanguageUtil_1.TezosLanguageUtil.hexToMicheline(originationMessage.substring(fieldoffset, fieldoffset + storagesize * 2)).code;
            fieldoffset += storagesize * 2;
            script = JSON.parse(`{ "script": [ ${code}, ${storage} ] }`);
        }
        let next;
        if (originationMessage.length > fieldoffset) {
            next = getOperationType(originationMessage.substring(fieldoffset, fieldoffset + 2));
        }
        let origination = {
            kind: "origination",
            source: source,
            balance: balanceInfo.value + "",
            delegate: hasDelegate ? delegate : undefined,
            fee: feeInfo.value + "",
            gas_limit: gasInfo.value + "",
            storage_limit: storageInfo.value + "",
            counter: counterInfo.value + "",
            script: hasScript ? script : undefined,
        };
        if (parseInt(hexOperationType, 16) < 100) {
            origination.manager_pubkey = manager_pubkey;
            origination.spendable = spendable;
            origination.delegatable = delegatable;
        }
        const envelope = {
            operation: origination,
            branch: branch,
            next: next,
            nextoffset: next ? fieldoffset : -1
        };
        return envelope;
    }
    TezosMessageCodec.parseOrigination = parseOrigination;
    function encodeOrigination(origination) {
        if (origination.kind !== 'origination') {
            throw new Error('Incorrect operation type');
        }
        let hex = TezosMessageUtil_1.TezosMessageUtils.writeInt(sepyTnoitarepo['origination']);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(origination.source).slice(2);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(origination.fee));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(origination.counter));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(origination.gas_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(origination.storage_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(origination.balance));
        if (origination.delegate !== undefined) {
            hex += TezosMessageUtil_1.TezosMessageUtils.writeBoolean(true);
            hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(origination.delegate).slice(2);
        }
        else {
            hex += TezosMessageUtil_1.TezosMessageUtils.writeBoolean(false);
        }
        if (!!origination.script) {
            let parts = [];
            parts.push(origination.script['code']);
            parts.push(origination.script['storage']);
            hex += parts
                .map(TezosLanguageUtil_1.TezosLanguageUtil.normalizePrimitiveRecordOrder)
                .map(p => TezosLanguageUtil_1.TezosLanguageUtil.normalizeMichelineWhiteSpace(JSON.stringify(p)))
                .map(p => TezosLanguageUtil_1.TezosLanguageUtil.translateMichelineToHex(p))
                .reduce((m, p) => { return m + ('0000000' + (p.length / 2).toString(16)).slice(-8) + p; }, '');
        }
        return hex;
    }
    TezosMessageCodec.encodeOrigination = encodeOrigination;
    function parseDelegation(delegationMessage, isFirst = true) {
        let hexOperationType = isFirst ? delegationMessage.substring(64, 66) : delegationMessage.substring(0, 2);
        if (getOperationType(hexOperationType) !== "delegation") {
            throw new Error("Provided operation is not a delegation.");
        }
        let fieldoffset = 0;
        let branch = "";
        if (isFirst) {
            branch = TezosMessageUtil_1.TezosMessageUtils.readBranch(delegationMessage.substring(fieldoffset, fieldoffset + 64));
            fieldoffset += 64 + 2;
        }
        else {
            fieldoffset += 2;
        }
        let source = '';
        if (parseInt(hexOperationType, 16) < 100) {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(delegationMessage.substring(fieldoffset, fieldoffset + 44));
            fieldoffset += 44;
        }
        else {
            source = TezosMessageUtil_1.TezosMessageUtils.readAddress(delegationMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let feeInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(delegationMessage, fieldoffset);
        fieldoffset += feeInfo.length;
        let counterInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(delegationMessage, fieldoffset);
        fieldoffset += counterInfo.length;
        let gasInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(delegationMessage, fieldoffset);
        fieldoffset += gasInfo.length;
        let storageInfo = TezosMessageUtil_1.TezosMessageUtils.findInt(delegationMessage, fieldoffset);
        fieldoffset += storageInfo.length;
        let hasDelegate = TezosMessageUtil_1.TezosMessageUtils.readBoolean(delegationMessage.substring(fieldoffset, fieldoffset + 2));
        fieldoffset += 2;
        let delegate = '';
        if (hasDelegate) {
            delegate = TezosMessageUtil_1.TezosMessageUtils.readAddress(delegationMessage.substring(fieldoffset, fieldoffset + 42));
            fieldoffset += 42;
        }
        let next;
        if (delegationMessage.length > fieldoffset) {
            next = getOperationType(delegationMessage.substring(fieldoffset, fieldoffset + 2));
        }
        const delegation = {
            kind: "delegation",
            source: source,
            delegate: hasDelegate ? delegate : undefined,
            fee: feeInfo.value + "",
            gas_limit: gasInfo.value + "",
            storage_limit: storageInfo.value + "",
            counter: counterInfo.value + ""
        };
        const envelope = {
            operation: delegation,
            branch: branch,
            next: next,
            nextoffset: next ? fieldoffset : -1
        };
        return envelope;
    }
    TezosMessageCodec.parseDelegation = parseDelegation;
    function encodeDelegation(delegation) {
        if (delegation.kind !== 'delegation') {
            throw new Error('Incorrect operation type');
        }
        let hex = TezosMessageUtil_1.TezosMessageUtils.writeInt(sepyTnoitarepo['delegation']);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(delegation.source).slice(2);
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(delegation.fee));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(delegation.counter));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(delegation.gas_limit));
        hex += TezosMessageUtil_1.TezosMessageUtils.writeInt(parseInt(delegation.storage_limit));
        if (delegation.delegate !== undefined && delegation.delegate !== '') {
            hex += TezosMessageUtil_1.TezosMessageUtils.writeBoolean(true);
            hex += TezosMessageUtil_1.TezosMessageUtils.writeAddress(delegation.delegate).slice(2);
        }
        else {
            hex += TezosMessageUtil_1.TezosMessageUtils.writeBoolean(false);
        }
        return hex;
    }
    TezosMessageCodec.encodeDelegation = encodeDelegation;
    function parseOperationGroup(hex) {
        let operations = [];
        let envelope = parseOperation(hex, idFirstOperation(hex));
        operations.push(envelope.operation);
        let groupOffset = 0;
        while (envelope.next) {
            groupOffset += envelope.nextoffset;
            envelope = parseOperation(hex.substring(groupOffset), envelope.next, false);
            operations.push(envelope.operation);
        }
        return operations;
    }
    TezosMessageCodec.parseOperationGroup = parseOperationGroup;
})(TezosMessageCodec = exports.TezosMessageCodec || (exports.TezosMessageCodec = {}));
//# sourceMappingURL=TezosMessageCodec.js.map